import { SBAPI } from '@supplement-bacon/react-toolkit/utils'
import { TableParams } from '@supplement-bacon/sb-table-filters'
import { Shift } from '../../models/business/PolicyShift'
import { SHIFTS_URL } from '../../utils/urls'

const fetchShifts = (params: TableParams) =>
  SBAPI.FetchPaginated<Shift[]>(SHIFTS_URL, params)

const fetchShiftById = (id: number, params?: TableParams) =>
  SBAPI.Fetch<Shift>(`${SHIFTS_URL}/${id}`, params)

const createShift = (shift: Shift) => SBAPI.Post(SHIFTS_URL, shift)

const updateShift = (shift: Shift) =>
  SBAPI.Put(`${SHIFTS_URL}/${shift.id}`, shift)

const deleteShift = (shift: Shift) => SBAPI.Delete(`${SHIFTS_URL}/${shift.id}`)

export { createShift, deleteShift, fetchShiftById, fetchShifts, updateShift }
